<template>
    <div>
        <b-row v-for="(history, index) in data" :history="history" :key="index" class="mb-2">
            <b-colxx lg="1">
                <span class="log-indicator align-middle" :class="logColor(history)"/>
            </b-colxx>

            <b-colxx lg="4">
                <span class="font-weight-medium">{{ history.data.attributes.action }}</span>
            </b-colxx>

            <b-colxx lg="4">
                <span class="font-weight-medium">{{ history.data.attributes.action_by }}</span>
            </b-colxx>

            <b-colxx lg="3" class="text-right">
                <span class="text-muted">{{ history.data.attributes.action_at }}</span>
            </b-colxx>
        </b-row>
    </div>
</template>

<script>
    export default {
        props: ['data'],

        methods: {
            logColor(history) {
                if (history.data.attributes.action === 'Updated') {
                    return 'border-info';
                } else if (history.data.attributes.action === 'Created') {
                    return 'border-success';
                } else if (history.data.attributes.action === 'Deleted') {
                    return 'border-danger';
                } else if (history.data.attributes.action === 'Activated') {
                    return 'border-info';
                } else if (history.data.attributes.action === 'Deactivated') {
                    return 'border-danger';
                }  else if (history.data.attributes.action === 'Online') {
                    return 'border-success';
                } else {
                    return 'border-warning';
                }
            },
        },
    }
</script>
